import { Share } from '@capacitor/share';
import { getPublicWebOrigin, platform } from '../config/runtime';

const normalizePath = (path) => {
  if (!path) return '/';
  return path.startsWith('/') ? path : `/${path}`;
};

export const buildCanonicalProjectShareUrl = (projectId) => {
  const origin = getPublicWebOrigin();
  const path = normalizePath(`discover/${projectId}`);
  return `${origin}${path}`;
};

export const buildProjectShareMessage = ({ projectName, url }) => {
  const trimmedName = projectName?.trim();
  if (trimmedName) {
    return `Check out this okio project: ${trimmedName}\n${url}`;
  }
  return `Check out this okio project: ${url}`;
};

export const buildProjectShareClipboardText = ({ projectName, url }) => {
  const trimmedName = projectName?.trim();
  if (trimmedName) {
    return `View my Okio project "${trimmedName}": ${url}`;
  }
  return `View my Okio project: ${url}`;
};

export const copyTextToClipboard = async (text) => {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', 'true');
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();

  const didCopy = document.execCommand('copy');
  document.body.removeChild(textarea);

  if (!didCopy) {
    throw new Error('Clipboard copy failed');
  }
};

const isCanceledShareError = (error) => {
  const message = `${error?.message || ''} ${error?.code || ''}`.toLowerCase();
  return message.includes('cancel') || message.includes('abort');
};

export const shareProjectNatively = async ({ projectName, url }) => {
  if (!platform.isNative()) {
    return 'unsupported';
  }

  try {
    await Share.share({
      title: projectName || 'OKIO project',
      text: buildProjectShareMessage({ projectName, url }),
      dialogTitle: 'Share project',
    });
    return 'shared';
  } catch (error) {
    if (isCanceledShareError(error)) {
      return 'cancelled';
    }
    throw error;
  }
};
